import React from "react";
import theLoanProcess from "../../PicesForPages/TheLoanProcess.jpg";
import FreeConsultation from "../Form/FreeConsultation";
import { Link } from "react-router-dom";

function TheLoanProcess() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={theLoanProcess}
          alt="tlpImage"
          className="background-video theLoanProcessImage"
        />
        <div className="purchasetopBox">
          {/* The existing Purchase span */}
          <span>The Loan Procedure</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">Pre-Qualification</span>
            <span className="purchaseBottomLeftContent">
              Pre-qualification is the initial step before the actual loan
              process begins. The lender collects details about your income and
              debts to determine how much home you might be able to afford.
              Knowing your budget before house hunting is wise. For refinancing
              your current home loan, pre-qualification helps assess if
              refinancing is a beneficial option.
            </span>

            <span className="purchaseBottomLeftHeader">Application</span>
            <span className="purchaseBottomLeftContent">
              The application phase starts the loan process after identifying a
              property to buy or deciding to refinance your existing home loan.
              You will fill out a mortgage application for a specific loan
              program and provide all necessary documents for processing. During
              this stage, various fees and down payment options are discussed.
              Within three days, the loan officer will provide a Good Faith
              Estimate (GFE) and a Truth-In-Lending Disclosure (TIL), detailing
              the rates and estimated loan costs.
            </span>

            <span className="purchaseBottomLeftHeader">Loan Processing</span>
            <span className="purchaseBottomLeftContent">
              The lender usually submits the application to an automated
              underwriting system to obtain necessary documents for loan
              approval, though manual underwriting can also occur. The processor
              reviews your credit reports and other documentation to verify
              employment, debts, and payment history. If there are any issues
              like late payments or collections, they will request explanations
              from you. They also check the appraisal and survey for any
              property concerns affecting loan approval, assembling the complete
              application package for the underwriter.
            </span>

            <span className="purchaseBottomLeftHeader">Underwriting</span>
            <span className="purchaseBottomLeftContent">
              The underwriter evaluates whether the processor's package meets
              the lender’s criteria. If more information is required, the loan
              is placed in "suspense" until you provide the additional
              documentation. Once the underwriter approves the loan, the lender
              issues a conditional commitment, orders title insurance, works to
              resolve any outstanding conditions, and schedules a closing. These
              conditions may involve credit, income, or property concerns.
            </span>

            <span className="purchaseBottomLeftHeader">Closing</span>
            <span className="purchaseBottomLeftContent">
              Closing happens once all conditions are met and the lender gives
              full loan approval. The lender funds the loan through a cashier’s
              check, draft, or wire transfer to the closing agent, who then
              disburses the funds in exchange for the property title transfer.
              This is when the loan process concludes, and you either refinance
              or purchase the house. The location of the closing varies by
              state, happening at an attorney's office, title company, escrow
              company, or even your home.
            </span>

            <div className="purchaseBottomLeftButton">
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="purchaseBottomLeftButtonLink"
              >
                APPLY!
              </Link>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default TheLoanProcess;
